// eslint-disable-next-line import/prefer-default-export
export function getCombinations(optionsArray) {
  const result = [];
  const f = (prefix, options) => {
    for (let i = 0; i < options.length; i += 1) {
      result.push([...prefix, options[i]]);
      f([...prefix, options[i]], options.slice(i + 1));
    }
  };
  f([], optionsArray);
  return result;
}

export function normalizeDiacriticsAndCase(str) {
  return typeof str === 'string'
    ? str
        .normalize('NFD')
        .replace(/’/g, "'")
        .replace(/[\u0300-\u036f]/g, '')
        .toUpperCase()
    : null;
}



// WEBPACK FOOTER //
// ./src/core/utils.js